export enum ComponentSize {
	XS = 'xs',
	S = 's',
	M = 'm',
	L = 'l',
}

export enum TempButtonsTypes {
	WARM = 'warm',
	WHITE = 'white',
	COLD = 'cold',
}

export enum CardVariant {
	listMenuCard = 'listMenuCard',
	widgetCard = 'widgetCard',
	drawer = 'drawer',
}

export enum SliderVariant {
	vertical = 'vertical',
	horizontal = 'horizontal',
	simple = 'vertical',
}
